import style from './style.scss'

type Props = {
  loginText: string
  createAccountText: string
  activeState: 'login' | 'create-account'
  onClick: () => void
}

function LoginOrCreateAccountNavigation({
  loginText,
  createAccountText,
  activeState,
  onClick,
}: Props) {
  return (
    <nav className={style.wrapper}>
      {activeState === 'login' && (
        <>
          <button className={style.button} onClick={onClick}>
            {createAccountText}
          </button>
          &nbsp;|&nbsp;
          <div>{loginText}</div>
        </>
      )}
      {activeState === 'create-account' && (
        <>
          <div>{createAccountText}</div>
          &nbsp;|&nbsp;
          <button className={style.button} onClick={onClick}>
            {loginText}
          </button>
        </>
      )}
    </nav>
  )
}

export default LoginOrCreateAccountNavigation
